<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout v-if="user_analytics.includes('R')" justify-start column
                      :class="{'pb-4': $vuetify.breakpoint.xs, 'pa-4': $vuetify.breakpoint.smAndUp}"
            >
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <h1 class="section-title-main my-3 mr-4 font-weight-regular" :class="{'px-3': $vuetify.breakpoint.xs}">{{ $t("Пользователи и организации") }}</h1>
                <div>
                    <v-layout wrap justify-space-between>
                        <v-tabs
                            v-model="active_tab"
                            slot="extension"
                            color="white"
                            :slider-color="tabsColor"
                            class="tabs-mobile"
                            :class="{'mr-4 mb-0': $vuetify.breakpoint.smAndUp}"
                        >
                            <v-tab v-if='user_management.includes("R")' href="#employees" class="wrapper-relative"
                                   :class="{'flex xs12': $vuetify.breakpoint.xs}"
                            >
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="users_employees"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 mt-1': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Сотрудники") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab href="#organizations" class="wrapper-relative" :class="{'flex xs12': $vuetify.breakpoint.xs}">
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="users_organizations"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 mt-1': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Организации") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <v-tab v-if='user_management.includes("U")' href="#user_requests" class="wrapper-relative notification-icon"
                                   :class="{'flex xs12': $vuetify.breakpoint.xs, 'notification-icon-requests': user_request_forms && user_request_forms.length}"
                                   :data-notification-count="requests_amout"
                            >
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="users_requests"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 mt-1': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Заявки на добавление пользователей") }}</v-flex>
                                </v-layout>
                            </v-tab>
                            <!-- <v-tab v-if="user.external" href="#org_requests" class="wrapper-relative"
                                   :class="{'flex xs12': $vuetify.breakpoint.xs}"
                            >
                                <v-layout row wrap align-center>
                                    <v-flex md2>
                                        <svg v-svg
                                             symbol="org_requests"
                                             size="32 32"
                                             class="icon"
                                             role="presentation"
                                        />
                                    </v-flex>
                                    <v-flex sm12 xs12 md9
                                            :class="{'pl-0 mt-1': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                                    >{{ $t("Заявки на добавление организаций") }}</v-flex>
                                </v-layout>
                            </v-tab> -->
                        </v-tabs>
                        <v-flex v-if="active_tab!='user_requests'" lg3 md4
                                sm6
                                justify-end d-flex :class="{'mx-3': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                        >
                            <buttonRed v-if="active_tab=='employees' && user_management.includes('C')" @click.native="OPEN_MODAL('add_user')">{{ $t("Добавить пользователя") }}</buttonRed>
                            <buttonRed v-if="active_tab=='organizations' && managment_of_organizations.includes('C')" @click.native="OPEN_MODAL('add_organization')">{{ $t("Добавить организацию") }}</buttonRed>
                        </v-flex>
                    </v-layout>
                </div>
                <v-tabs-items v-model="active_tab" class="my-4" touchless>
                    <v-tab-item value="employees">
                        <UsersEmployees />
                    </v-tab-item>
                    <v-tab-item value="organizations">
                        <UsersOrganizations :create_access="managment_of_organizations.includes('C')" />
                    </v-tab-item>
                    <v-tab-item value="user_requests">
                        <UsersRequests />
                    </v-tab-item>
                    <!-- <v-tab-item id="org_requests">
                        <OrgRequests />
                    </v-tab-item> -->
                </v-tabs-items>
            </v-layout>
            <div v-else class="pa-4">{{ $t("Доступ запрещён") }}</div>
        </div>
        <v-dialog :value="add_user.active" persistent content-class="scrolled-dialog">
            <addUserModal v-if="add_user.active" />
        </v-dialog>
        <v-dialog :value="add_organization.active" persistent content-class="scrolled-dialog">
            <addOrgModal v-if="add_organization.active" />
        </v-dialog>
        <v-dialog :value="accept_request.active" persistent content-class="scrolled-dialog">
            <acceptRequestModal v-if="accept_request.active" />
        </v-dialog>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed   from '@/components/ui/buttons/button_red';
import addUserModal from './Users_modals/Add_user_modal';
import addOrgModal from './Users_modals/Add_org_modal';
import acceptRequestModal from './Users_modals/Accept_request';
import UsersEmployees from './Tables/Users_employees';
import UsersOrganizations from './Tables/Users_organizations';
import UsersRequests from './Tables/Users_requests';
import OrgRequests from './Tables/Org_requests';
import {mapState, mapGetters, mapMutations} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonRed,
    addUserModal,
    addOrgModal,
    acceptRequestModal,
    UsersEmployees,
    UsersOrganizations,
    UsersRequests,
    OrgRequests,
  },
  data() {
    return {
      search                    : '',
      user_analytics            : '',
      user_management           : '',
      managment_of_organizations: '',
    };
  },
  computed: {
    ...mapState('users/requests', ['requests_amout']),
    ...mapGetters('users/requests', [
      'user_request_forms',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
      'accept_request',
    ]),
    ...mapGetters('users', [
      'tab',
      'showed_filter',
    ]),
    ...mapGetters('users/employees', [
      'users_employees_table',
      'organizations',
      'roles',
      'specialities',
    ]),
    ...mapGetters('users/organizations', [
      'users_organizations_table',
      'groups',
      'types',
      'departments',
      'org_filters',
    ]),
    active_tab: {
      get() {
        return this.tab;
      },
      set($event) {
        localStorage.setItem('active_tab_users', $event);
        return this.SET_ACTIVE_TAB($event);
      },
    },
    tabsColor() {
      if (this.tab=='employees') {
        return '#44b69e';
      } else if (this.tab=='organizations') {
        return '#84a45d';
      } else {
        return '#e2173d';
      }
    },
  },
  mounted() {
    if (this.$route.query.filter_org) {
      this.SET_ACTIVE_TAB('employees');
    } else {
      this.SET_ACTIVE_TAB(localStorage.getItem('active_tab_users'));
    }

    this.user_analytics = ['R'];
    if (localStorage.user !== 'undefined') {
      this.user_analytics = this.user.role.user_analytics.rights;
      this.user_management = this.user.role.user_managment.rights;
      this.managment_of_organizations = this.user.role.managment_of_organizations.rights;
    }
  },
  methods: {
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
  },
};
</script>
